import { Ass_10, Lia_02 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const VAT_CREDIT: Template = {
  id: "52e365c9-774b-49f2-8735-ddbf5b4f4fe3",
  name: "Enammakstud käibemaksu kandmine ettemaksuks",
  description:
    "Kuu viimasel kuupäeval jooksva kuu käibemaksu (Lia-02) kandmine ettemaksuks (Ass-10)." +
    " Õige summa muudab jooksva kuu käibemaksu saldo 0-ks.",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Enammakstud käibemaksu arvestus"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Enammakstud käibemaksu arvestus ettemakseks",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Ass_10,
          credit: Lia_02
        }
      ]
    };

    return { type: "success", entry };
  }
};
